import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
var AdminService = /** @class */ (function (_super) {
    tslib_1.__extends(AdminService, _super);
    function AdminService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: 'makpak/findMaklerPakete'
        }) || this;
        _this.http = http;
        return _this;
    }
    AdminService.prototype.findMaklerPakete = function () {
        //debugger;
        return _super.prototype.get.call(this, "").pipe(map(function (res) {
            console.log("res: " + res);
            return res;
        }));
    };
    AdminService.prototype.getAllAdmins = function () {
        return _super.prototype.get.call(this, "alle").pipe(map(function (res) {
            return res;
        }));
    };
    AdminService.prototype.addNewAdmin = function (newAdmin) {
        var url = this.buildUrl() + "/speichern";
        return this.http
            .put(url, newAdmin).pipe(map(function (res) {
            return res;
        }));
    };
    AdminService.prototype.deleteAdmin = function (admin) {
        var url = this.buildUrl() + "/entfernen?";
        var urlParam = url + "bensl=" + admin.bensl;
        /*
        let params = new URLSearchParams();
        params.append("bensl", admin.bensl);
    
        let options = new RequestOptions({
          params: params
        });*/
        return this.http
            .delete(urlParam)
            .toPromise()
            .then(function () { return null; });
    };
    AdminService.prototype.isAdmin = function (bensl) {
        var urlParam = "ermitteln?";
        urlParam += bensl ? "bensl=" + bensl : "";
        return _super.prototype.get.call(this, urlParam).pipe(map(function (res) {
            return res.bensl && res.bensl.toLowerCase() == bensl.toLowerCase();
        }), catchError(function (e) {
            return observableThrowError(false);
        })); //TODO changed this
        // .catch((e: any) => {
        //   return observableThrowError(false);
        // });
    };
    return AdminService;
}(RESTService));
export { AdminService };
